package com.evoapps.evoshift.domain.util

internal actual fun fakeNowProperty(): String? = null
